<template>
  <div class="row">
    <div class="col-lg-3 pl-1">
      <b-form-group class="mb-3">
        <b-form-input
          id="search"
          placeholder="Busqueda"
          name="search"
          size="sm"
          v-model="onTheFlyConfig.name"
          @input="onTheFlyChange"
        />
      </b-form-group>
    </div>
  </div>
</template>
<script>

import { FILTER_ON_THE_FLY_COMPARATORS } from '../config';

export default {
  data() {
    return {
      onTheFlyConfig: {
        name: ''
      }
    };
  },
  methods: {
    onTheFlyChange() {
      const filters = Object.entries(this.onTheFlyConfig)
        .filter(([, value]) => !!value)
        .reduce((memo, [key, value]) => ({
          ...memo,
          [key]: FILTER_ON_THE_FLY_COMPARATORS[key](value)
        }), {});
      this.$emit('on-the-fly-filters-change', filters);
    }
  }
};

</script>
